//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default{
		name:'down',
		data(){
			return{
				down_state:false,
				sort_mode: [{
						text: '按价格从高到低排序',
						direction: 'desc',
						sort: 'goodsPrice'
					},
					{
						text: '按价格从低到高排序',
						direction: 'asc',
						sort: 'goodsPrice'
					},
					{
						text: '按获取时间排序',
						direction: 'desc',
						sort: 'getTime'
					}
				],
				
				sort_text:''
			}
		},
		methods:{
			//触发下拉
			todown(){
				this.down_state = !this.down_state
			},
			
			//下拉选中
			to_item(item){
				this.sort_text = item.text
				this.down_state = false
				this.$emit('down_item',item)
			},
			//划离收起
			mouseleave(){
				this.down_state = false
			}
		}
	}
